/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { InAppMessageDeliveryPriority } from 'cio/utils/in-app/message-config';

interface MessagePriorityArgs {
  priority: InAppMessageDeliveryPriority;
  onChange: (priority: InAppMessageDeliveryPriority) => unknown;
}

export default class MessagePriority extends Component<MessagePriorityArgs> {
  get isHigh() {
    return this.args.priority === InAppMessageDeliveryPriority.High;
  }
  get isMedium() {
    return this.args.priority === InAppMessageDeliveryPriority.Medium;
  }
  get isLow() {
    return this.args.priority === InAppMessageDeliveryPriority.Low;
  }

  @action
  setHigh() {
    this.args.onChange(InAppMessageDeliveryPriority.High);
  }
  @action
  setMedium() {
    this.args.onChange(InAppMessageDeliveryPriority.Medium);
  }
  @action
  setLow() {
    this.args.onChange(InAppMessageDeliveryPriority.Low);
  }
}
